module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "booksection"
  }, [_c('p', {
    staticClass: "img"
  }, [_c('a', {
    attrs: {
      "id": "page9"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p9.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page9"
    }
  }), _c('h1', {
    staticClass: "head"
  }, [_c('a', {
    attrs: {
      "id": "page9"
    }
  }), _c('a', {
    attrs: {
      "id": "page8"
    }
  }, [_c('span', {
    staticClass: "col1b"
  }, [_vm._v("Jamye")])])]), _c('a', {
    attrs: {
      "id": "page8"
    }
  }, [_c('p', {
    staticClass: "intro_text"
  }, [_vm._v("SEX IS . . .")]), _vm._v(" "), _c('p', {
    staticClass: "intro_text"
  }, [_c('span', {
    staticClass: "font1"
  }, [_vm._v("When you think of those two small words, placed side by side, one next to the other")]), _vm._v(", plenty of adjectives run through the mind. Sex is . . . fun. Silly. Explosive. Intimate. Deep. Dynamic. Average. Unexpected. Mind-blowing. Pleasure. Pain. Release. Love.")]), _vm._v(" "), _c('p', {
    staticClass: "intro_text"
  }, [_vm._v("If you learn only one sex tip from this book, it should be this: enthusiasm. Sex is best with a lot of enthusiasm. There’s not one right way to have sex, but if you’re not excited to be doing it, it can feel wrong.")]), _vm._v(" "), _c('p', {
    staticClass: "intro_text"
  }, [_vm._v("What I also love about sex is that it’s fluid. It can, and should, change over the course of a lifetime or a relationship. It can be vanilla one day and chocolate the next. You can do it like rabbits or like Kama Sutra masters. You can explore sex with one person or more, of more than one gender.")]), _vm._v(" "), _c('p', {
    staticClass: "intro_text"
  }, [_vm._v("We use the pronouns “he” and “she” in this book for simplicity’s sake. But sex and gender aren’t always simple. So, we’d like to take a moment to acknowledge the many ways and partners one person can explore. While you’ll see men and women getting down on most of these pages, we’re down with you trying anything in this book with any person or people you desire.")]), _vm._v(" "), _c('p', {
    staticClass: "intro_text"
  }, [_vm._v("My hope is that this book inspires you to make new choices, and to celebrate the choices you’ve already made. To enjoy what works for you and to laugh about the things that don’t. Try to continuously create and explore your sexual self and love the sex you choose to have. Now go to it!")]), _vm._v(" "), _c('p', {
    staticClass: "right1"
  }, [_vm._v("Love,")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/sign.jpg"
    }
  })])])]), _c('a', {
    attrs: {
      "id": "page8"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b4216a92","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/fmpart3.vue
// module id = 72
// module chunks = 0